import React from 'react';
import Footer from '@/features/Footer/Footer';

const FooterWrapper = (props) => {
    return <Footer {...props} disableCSR={true} />;
};

export default FooterWrapper;
